import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../layout.css";

import logo1 from "../../Asserts/Images/dashboardLogo.png";
import { FiChevronDown, FiChevronUp,FiUsers,FiUserPlus } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";
import { FaUser, FaFileAlt, FaCommentDots } from "react-icons/fa";
import { IoIosHelpCircle } from "react-icons/io";
import { FaSackDollar } from "react-icons/fa6";
import { IoLocationOutline, IoMenu } from "react-icons/io5";
import { MdOutlineDashboard, MdOutlineVerifiedUser } from "react-icons/md";
import { LuBuilding2 } from "react-icons/lu";
import { IoNotificationsOutline } from "react-icons/io5";
import { AiOutlineSafety } from "react-icons/ai";
import { TbScanEye } from "react-icons/tb";
import { CiCircleQuestion } from "react-icons/ci";
import { IoSettingsOutline } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import { GoShieldX } from "react-icons/go";
import { LuNotebookPen } from "react-icons/lu";
import { TbRefresh } from "react-icons/tb";

function SidebarAdmin() {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const location = useLocation();
  const isCertificationActive =
  location.pathname.startsWith("/certification") ||
  location.pathname.startsWith("/addnewcertification") ||
  location.pathname.startsWith("/view-certification") ||
  location.pathname.startsWith("/edit-certification");

    const isIndividualCertificationActive =
  location.pathname.startsWith("/individual-trainee-page") ||
  location.pathname.startsWith("/add-new-individual-certification") ||
  location.pathname.startsWith("/view-individual-certification") ||
  location.pathname.startsWith("/edit-individual-certification");

  const isCompaniesActive =
  location.pathname.includes("/companies") ||
  location.pathname.startsWith("/company-details/")



   const isActiveServelliance=
   location.pathname.startsWith("/survelliance-audit-one") ||
    location.pathname === "/remainder-page";
   
  const isActiveSecondServelliance=
   location.pathname.startsWith("/second-survelliance-audit") ||
    location.pathname === "/second-survelliance-audit-remainder";

  const isActiveRenewedCertification =
  location.pathname.startsWith("/renewed-certification-page") ||
  location.pathname.startsWith("/add-renew-certification") ||
  location.pathname.startsWith("/view-renewed-certification") ||
  location.pathname.startsWith("/edit-renewed-certification");



  const menuSections = {
    dashboard: [
      {
        id: "dashboard",
        label: "Dashboard",
        to: "/dashboard",
        icon: (
          <span className="sidebar-icon-bg">
            <MdOutlineDashboard className="sidebar-icon" size={24} />
          </span>
        ),
      },
      {
        id: "companies",
        label: "Companies",
        to: "/companies",
        icon: (
          <span className="sidebar-icon-bg">
            <LuBuilding2 className="sidebar-icon" size={24} />
          </span>
        ),
      },
      {
        id: "certifications",
        label: "Company Certifications",
        to: "/certification",
        icon: (
          <span className="sidebar-icon-bg">
            <AiOutlineSafety className="sidebar-icon" size={24} />
          </span>
        ),
      },
      {
        id: "individual-trainee",
        label: "Individual Trainee",
        to: "/individual-trainee-page",
        icon: (
          <span className="sidebar-icon-bg">
            <AiOutlineSafety className="sidebar-icon" size={24} />
          </span>
        ),
      },
      {
        id: "1st-surveillance-audits",
        label: "1st Surveillance Audits",
        to: "/survelliance-audit-one",
        icon: (
          <span className="sidebar-icon-bg">
            <TbScanEye className="sidebar-icon" size={24} />
          </span>
        ),
      },
      {
        id: "2nd-surveillance-audits",
        label: "2nd Surveillance Audits",
        to: "/second-survelliance-audit",
        icon: (
          <span className="sidebar-icon-bg">
            <TbScanEye className="sidebar-icon" size={22} />
          </span>
        ),
      },
      {
        id: "expired-certification",
        label: "Expired Certifications",
        to: "/expired-certifications",
        icon: (
          <span className="sidebar-icon-bg">
            <GoShieldX className="sidebar-icon" size={24} />
          </span>
        ),
      },
      {
        id: "renewed-certification",
        label: "Renewal Certifications",
        to: "/renewed-certification-page",
        icon: (
          <span className="sidebar-icon-bg">
            <TbRefresh className="sidebar-icon" size={24} />
          </span>
        ),
      },
      {
        id: "agents",
        label: "Agents",
        to: "/agents-page",
        icon: (
          <span className="sidebar-icon-bg">
            <FiUsers className="sidebar-icon" size={24} />
          </span>
        ),
      },
      {
        id: "users",
        label: "Add Users",
        to: "/usertable-page",
        icon: (
          <span className="sidebar-icon-bg">
            <FiUserPlus className="sidebar-icon" size={22} />
          </span>
        ),
      },
      {
        id: "notifications",
        label: "Notifications",
        to: "/notification-table/notification",
        icon: (
          <span className="sidebar-icon-bg">
            <IoNotificationsOutline className="sidebar-icon" size={22} />
          </span>
        ),
      },
      {
        id: "reports",
        label: "Reports",
        to: "/reports-page",
        icon: (
          <span className="sidebar-icon-bg">
            <LuNotebookPen  className="sidebar-icon" size={22} />
          </span>
        ),
      },
    ],
    others: [
      {
        id: "reports",
        label: "Reports",
        to: "/reports-analytics/customer-growth-reports",
        icon: (
          <span className="sidebar-icon-bg">
            <CiCircleQuestion className="sidebar-icon" size={22} />
          </span>
        ),
      },
      {
        id: "settings",
        label: "Settings",
        to: "/settings",
        icon: (
          <span className="sidebar-icon-bg">
            <IoSettingsOutline className="sidebar-icon" size={22} />
          </span>
        ),
      },
    ],
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleMenu = (menu) => {
    setExpandedMenu(expandedMenu === menu ? null : menu);
  };

  return (
    <>
      {/* Mobile toggle button */}
      <button
        className="toggle-btn-header d-block d-sm-block d-md-block d-lg-none"
        onClick={toggleSidebar}
      >
        <IoMenu style={{ width: "30px", height: "30px", position: "fixed" }} />
        <span className="visually-hidden">Toggle sidebar</span>
      </button>

      <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <aside className={`sidebar-content ${isSidebarOpen ? "open" : ""}`}>
          <div className="sidebar-header">
            <img
              src={logo1}
              alt="Logo"
              className="sidebar-logo"
              onClick={() => navigate("/dashboard")}
            />
            <h3>EQCAS</h3>
            <button
              className="close-btn menu-close-button-response"
              onClick={toggleSidebar}
            >
              <IoMdClose />
            </button>
          </div>

          <nav className="sidebar-nav mt-4">
            {/* Top Menu */}
            <div className="sidebar-nav-links sidebar-nav-top">
              <ul>
                {menuSections.dashboard.map((menuItem) => (
                  <li key={menuItem.id}>
                    <NavLink
                      to={menuItem.to}
                      className={({ isActive }) => {
                        const isCert =
                          menuItem.id === "certifications" &&
                          isCertificationActive;
                          const isIndiviual = menuItem.id === "individual-trainee" && isIndividualCertificationActive;
                          const isCerttwo = menuItem.id === "1st-surveillance-audits" && isActiveServelliance;
                          const isCertthree = menuItem.id === "2nd-surveillance-audits" && isActiveSecondServelliance;
                          const isCertFour = menuItem.id === "companies" && isCompaniesActive;
                          const isCertFive = menuItem.id === "renewed-certification" && isActiveRenewedCertification;

                        return isActive || isCert || isCerttwo || isCertthree || isCertFour || isIndiviual || isCertFive
                          ? "nav-link active-nav-links"
                          : "nav-link";
                      }}
                      onClick={() => {
                        if (isSidebarOpen) toggleSidebar();
                      }}
                    >
                      {menuItem.icon}
                      {menuItem.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            {/* Bottom Menu */}
            <div className="sidebar-nav-links sidebar-nav-bottom">
              <ul>
                {menuSections.others.map((menuItem) => (
                  <li key={menuItem.id}>
                    <NavLink
                      to={menuItem.to}
                      {...(menuItem.to === "/" ? { end: true } : {})}
                      className={({ isActive }) =>
                        isActive ? "nav-link active-nav-links" : "nav-link"
                      }
                      onClick={() => {
                        if (isSidebarOpen) toggleSidebar();
                      }}
                    >
                      {menuItem.icon}
                      {menuItem.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </nav>
        </aside>
      </div>
    </>
  );
}

export default SidebarAdmin;
